<template>
  <Info title="Contact Information">
    <article>
      <p>
        Please contact us via
        <a
          href="https://www.facebook.com/Quick-Tourney-406848122730934/"
        >our facebook page.</a>
      </p>
      <div
        class="fb-like"
        data-href="https://www.facebook.com/Quick-Tourney-406848122730934/"
        data-layout="standard"
        data-action="like"
        data-size="large"
        data-show-faces="true"
        data-share="true"
      ></div>
      <div
        class="fb-like"
        data-href="https://www.facebook.com/Quick-Tourney-406848122730934/"
        data-layout="standard"
        data-action="recommend"
        data-size="large"
        data-show-faces="true"
        data-share="true"
      ></div>
    </article>
  </Info>
</template>

<script>
import Info from "@/components/Info.vue";

export default {
  name: "ContactInfo",
  components: { Info }
};
</script>


// WEBPACK FOOTER //
// ContactInfo.vue?f2d797b6